import { useAppDispatch } from "store";

import PagePreviousIcon from "@rsuite/icons/PagePrevious";

import {
  useGenerateResetPasswordTokenMutation,
  useLoginMutation,
} from "_services/auth";

import { ReactComponent as Logo } from "ressources/icons/logo.svg";

import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import jwt_decode from "jwt-decode";


import { Helmet } from "react-helmet";

import "./style.css";

import { useNavigate, useLocation } from "react-router";
import { authSetToken } from "_utils/slices/authSlice";
import { withBasePath } from "_config/basePath";
import ForgotPasswordModal from "./ForgotPasswordModal";
import RolePicker from "components/advisor/RolePicker";
import AuthGoogleChoice from "components/advisor/AuthGoogleChoice";

import { useGTMDispatch } from "@elgorditosalsero/react-gtm-hook";

import { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

export default function Login() {
    const dispatch = useAppDispatch();

    const [login, { isError, isLoading }] = useLoginMutation();
    const [role, setRole] = useState("student");
  const [generateResetPassword] = useGenerateResetPasswordTokenMutation();
  const [showForgotPasswordModal, setshowForgotPasswordModal] = useState(false);

  const sendGTM = useGTMDispatch();
  const { t, i18n } = useTranslation();

  const LoginSchema = Yup.object().shape({
    email: Yup.string()
      .email(t('email-error')).required(t("email-required")),
    password: Yup.string().required(t("password-required")),
  });

  const resetPassword = () => {
    const email = document.getElementById("email").value;
    if (email.length > 0) {
      setshowForgotPasswordModal(true);
      generateResetPassword({ email: email });
    }
  };

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const token = new URLSearchParams(location.search).get("token");
    const from = new URLSearchParams(location.search).get("method");
    const isSignin = new URLSearchParams(location.search).get("signin");
    if (token) {
      setTimeout(() => {
        if (isSignin == "true") {
          const event = { "event": "signUpDone", "value": { "method": from, "invited": false } };
          sendGTM(event);
          window.fathom?.trackGoal('CM6QIAE5', 0);
        }
        else {
          const event = { "event": "loginDone", "value": { "method": from, "userID": jwt_decode(token)?.sub } };
          sendGTM(event);
          window.fathom?.trackGoal('KXCQ6K2Q', 0);
        }
        dispatch(authSetToken({ token }));
      }, 500);
    }
  }, [])


  return (
    <div className="login bg-gradient-blue">
      <Helmet>
        <title>Thesis.center - Connexion</title>
        <meta
          name="description"
          content="Connecte toi à Thesis pour poursuivre la rédaction de tes travaux. Oublie le formalisme et concentre toi sur le contenu."
        />
      </Helmet>
      <div className="signup-back" onClick={() => navigate("/")}>
        <PagePreviousIcon
          className="signup-back-icon"
          style={{
            cursor: "pointer",
          }}
        />
        {t('back')}
      </div>
      <div className="login-card">
        <RolePicker value={role} onChange={setRole} />
        {/* <div className="login-card-header">
          Connexion
        </div> */}
        <AuthGoogleChoice role={role}><div className="login-card-alternate">
          {/* <div className="login-card-alternate-text">Me connecter avec :</div> */}
          <button
            onClick={() => {
              window.location.href = withBasePath(`/api/oauth/google?role=${role}`);
            }}
            className="login-card-google login-card-alternate-button"
          >
            <img width="15px" src={withBasePath("/google-logo.png")} alt="" />
            {t('continue-with')} Google
          </button>
        </div>
        <div className="login-card-or">
          <div className="grey-line-left"></div>
          <span>{t('or').toUpperCase()}</span>
          <div className="grey-line-right"></div>
        </div></AuthGoogleChoice>
        <div className="login-card-form">
          {/* <div className="login-card-form-text">Je me connecte :</div> */}
          <Formik
            initialValues={{
              email: "",
              password: "",
            }}
            validationSchema={LoginSchema}
            onSubmit={async (values) => {
              try {
                await login({ ...values, role }).unwrap();
                sendGTM({ "event": "loginDone", "value": { "method": "classic" } });
              } catch { /* The mutation state displays the authentication error. */ }
            }}
          >
            {({ errors, touched }) => (
              <Form>
                <Field
                  id="email"
                  name="email"
                  placeholder={t('email')}
                  type="email"
                />
                {errors.email && touched.email ? (
                  <div className="form-validation-error">{errors.email}</div>
                ) : null}
                <Field
                  id="password"
                  type="password"
                  name="password"
                  placeholder={t('password')}
                />
                {errors.password && touched.password ? <div className="form-validation-error">{errors.password}</div> : null}
                {isError ? (
                  <div className="form-validation-error">
                    {t('wrong-email-or-password')}
                  </div>
                ) : null}
                <div className="login-card-form-buttons">
                  <button
                    className="login-card-form-forgot-button"
                    onClick={() => resetPassword()}
                    type="button"
                  >
                    {t('forgot-password')}
                  </button>
                  <button
                    className="login-card-form-submit-button"
                    type="submit"
                    disabled={isLoading}
                  >
                    {isLoading ? (i18n.language.startsWith("fr") ? "Connexion…" : "Signing in…") : t('connexion')}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
          <div className="login-card-footer">
            <Logo className="login-card-logo" />
          </div>
        </div>
        <ForgotPasswordModal
          show={showForgotPasswordModal}
          setShow={setshowForgotPasswordModal}
        />
      </div>
    </div>
  );
};
